import { useState, useCallback, useEffect } from 'react';

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, chatId: null });

  const hideContextMenu = useCallback(() => {
    setContextMenu({ visible: false, x: 0, y: 0, chatId: null });
  }, []);

  const handleContextMenu = useCallback((event, chatId) => {
    event.preventDefault();
    setContextMenu({
      visible: true,
      x: event.clientX,
      y: event.clientY,
      chatId
    });
  }, []);

  const handleMenuClick = useCallback((event, chatId) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    setContextMenu({
      visible: true,
      x: rect.left,
      y: rect.bottom,
      chatId
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = () => {
      if (contextMenu.visible) {
        hideContextMenu();
      }
    };
    
    if (contextMenu.visible) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [contextMenu.visible, hideContextMenu]);

  return {
    contextMenu,
    hideContextMenu,
    handleContextMenu,
    handleMenuClick
  };
};